
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const TRAILER_CDN = process.env.REACT_APP_AWS_CONTENT_DOMAIN
const CONTENT_DOMAIN = process.env.REACT_APP_CONTENT_DOMAIN
const USER_API_URL = process.env.REACT_APP_USER_API;
const DATA1_API_URL = process.env.REACT_APP_DATA_API;
const GARMENT_API_URL = process.env.REACT_APP_GARMENT_API;
const TRAKT_API_URL = process.env.REACT_APP_TRAKT_API;
const CHAT_SERVER_URL = process.env.REACT_APP_CHAT_API;

const POSTER_BASE = "https://image.tmdb.org/t/p/w300";
const BACKDROP_BASE = "https://image.tmdb.org/t/p/w500"
const MOVIE_DB_API = process.env.REACT_APP_MOVIE_DB_API;
const MOVIE_DB_KEY = process.env.REACT_APP_MOVIE_DB_API_KEY;

const ACTOR_URL = `${DATA1_API_URL}/actor`;
const ACTOR_TAG_URL = `${DATA1_API_URL}/actors/tags`;
const ACTOR_TAG_TYPE_URL = `${DATA1_API_URL}/actors/tagTypes`;

const MOVIE_URL = `${DATA1_API_URL}/scenes/movies`;
const SITE_URL = `${DATA1_API_URL}/scenes/sites`;
const STATUS_URL = `${DATA1_API_URL}/scenes/status`;

const DATA_API = {
    ACTOR_URL, 
    ACTOR_TAG_URL, ACTOR_TAG_TYPE_URL,
    MOVIE_URL, SITE_URL, STATUS_URL
}

// Garment API URLs
const GARMENT_LIST_URL = `${GARMENT_API_URL}/garments`;
const GARMENT_BY_ACTOR_URL = `${GARMENT_API_URL}/garments/actor`;
const GARMENT_DETAIL_URL = `${GARMENT_API_URL}/garments`;
const GARMENT_CATEGORIES_URL = `${GARMENT_API_URL}/garments/attributes/categories`;
const GARMENT_STYLES_URL = `${GARMENT_API_URL}/garments/attributes/styles`;
const GARMENT_PATTERNS_URL = `${GARMENT_API_URL}/garments/attributes/patterns`;
const GARMENT_TEXTURES_URL = `${GARMENT_API_URL}/garments/attributes/textures`;
const GARMENT_MATERIALS_URL = `${GARMENT_API_URL}/garments/attributes/materials`;
const SCENE_GARMENT_TAG_URL = `${GARMENT_API_URL}/garments/scenes`;
const ALBUM_GARMENT_TAG_URL = `${GARMENT_API_URL}/garments/albums`;

const GARMENT_API = {
    GARMENT_LIST_URL,
    GARMENT_BY_ACTOR_URL,
    GARMENT_DETAIL_URL,
    GARMENT_CATEGORIES_URL,
    GARMENT_STYLES_URL,
    GARMENT_PATTERNS_URL,
    GARMENT_TEXTURES_URL,
    GARMENT_MATERIALS_URL,
    SCENE_GARMENT_TAG_URL,
    ALBUM_GARMENT_TAG_URL
}

const AUTH_URL = `${USER_API_URL}/auth/authenticated`;
const LOGIN_URL = `${USER_API_URL}/auth/login`;
const SIGNUP_URL = `${USER_API_URL}/auth/signup`;
const SCENE_USERINFO_URL = `${USER_API_URL}/scenes`;
const ADMIN_URL = `${USER_API_URL}/admin`;
const USERS_URL = `${USER_API_URL}/admin/users`;
const ROLES_URL = `${USER_API_URL}/admin/roles`;
const SCENE_FAVORITES_URL = `${USER_API_URL}/users/favorite/scenes`;
const SCENE_HISTORY_URL = `${USER_API_URL}/users/history/scenes`;
const ACTOR_HISTORY_URL = `${USER_API_URL}/users/history/actors`;
const SCENE_LIKE_URL = `${USER_API_URL}/users/like/scenes`;
const SCENE_PLAYLIST_URL = `${USER_API_URL}/playlist`;
const SCENE_SEARCH_HISTORY = `${USER_API_URL}/users/history/search/scenes`;
const ACTOR_SEARCH_HISTORY = `${USER_API_URL}/users/history/search/actors`;

const USER_API ={
    AUTH_URL, LOGIN_URL, SIGNUP_URL, SCENE_USERINFO_URL, 
    USERS_URL, ROLES_URL, ADMIN_URL,
    SCENE_FAVORITES_URL,
    SCENE_HISTORY_URL,
    ACTOR_HISTORY_URL,
    SCENE_LIKE_URL,
    SCENE_PLAYLIST_URL,
    SCENE_SEARCH_HISTORY,
    ACTOR_SEARCH_HISTORY,
    USER_API_URL
}

const mobileSize = 800;

export const PERM ={
    NONE: 'NONE',
    READ: 'READ',
    WRITE: 'WRITE',
    ADMIN: 'ADMIN',
    ADULT: 'ADULT'
}

export const TAGS ={
    ACTORTAG: 'type',
    SCENECATEGORY: 'category'
}

export const sceneCategoryTags = ["Actor", "Scene", "Role", "Location", "Object", "Outfit"];

const constants={
    MONTHS,
    DATA_API,
    GARMENT_API,
    DATA1_API_URL,
    USER_API,
    USER_API_URL,
    TRAKT_API_URL,
    CHAT_SERVER_URL,
    POSTER_BASE,
    BACKDROP_BASE,
    MOVIE_DB_API,
    MOVIE_DB_KEY,
    CONTENT_DOMAIN,
    mobileSize,
    TRAILER_CDN
};

export default constants;